import React, { Fragment, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import moment from "moment";
import { VaporVerticalLine } from "../../../../vapor";
import { Popover } from "antd";
import { getFixedAssetDetailsLogs } from "../../../../../store/actions/precog/assets";
import { useDispatch } from "react-redux";
import LoaderSimple from "../../../../general/loader";
import RevaluationSubSection from "./revaluationSubsection";
import RemovalSubSection from "./removalSubsection";
import ContainerWithVerticalLine from "./containerWithVerticalLine";

import "../style.css";
import TypesFilters from "./typeFilter"; 
import MovementDrawerDetails from "./movementDrawerDetail/movementDrawerDetails";

const filterList = ["STATUTORY", "TAX", "IRAP", "TAX_RELIEF"]; 

/**
 * Home page of movement section in Drawer cespiti
 * @returns 
 */
const MovementsSection = ({ setHideHeader, setBottomButtons, assetsDetails }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [state, setState] = useState(null);
  const [showPopover, setShowPopover] = useState(false);
  const [addRevaluation, setAddRevaluation] = useState(false);
  const [removalRevaluation, setRemovalRevaluation] = useState(false);
  const [minDatePicker, setMinDatePicker] = useState(null);
  const [activeFilter, setActiveFilter] = useState(filterList[0]);
  const [showDrawerDetail, setShowDrawerDetail] = useState(false);
  const [selectedSequence, setSelectedSequence] = useState(null);

  useEffect(() => {    
    if (!assetsDetails?.id || !assetsDetails?.businessId) return;
    dispatch(getFixedAssetDetailsLogs(
      assetsDetails?.id, assetsDetails?.businessId, activeFilter
    ))// TODO change id in futur
      .then(res => {
        setState({
          ...res,
          residualReferenceDate: moment(res.residualReferenceDate).format("DD/MM/YYYY"),
          activationDate: moment(res.activationDate).format("DD/MM/YYYY")
        });
      })
      .catch(err => console.err(err));
  }, [assetsDetails?.businessId, assetsDetails?.id, activeFilter]);

  useEffect(()=>{
    if (!addRevaluation && !removalRevaluation)
      setBottomButtons([]);
  },[addRevaluation, removalRevaluation]);

  useEffect(() => {
    if (!state?.logs || state.logs.length === 0) return;
    const maxDate = new Date(Math.max(...state.logs.map(element => {
      return new Date(element.date);
    })));    
    // il giorno stesso non può essere venduto
    // setMinDatePicker(new Date(maxDate.setDate(maxDate.getDate() + 1)));
    setMinDatePicker(maxDate);
  }, [state?.logs]);
  
  if (!state) {
    return <div data-testid="MovementsSectionLoading">
      <LoaderSimple message={intl.formatMessage({id: "preCog.assetsTab.drawer.movements.loading"})} />
    </div>;
  }

  return (
    <div>
      {showDrawerDetail === false && 
        <div data-testid="MovementsSection">
          {!addRevaluation && !removalRevaluation && 
      <div>
        <ContainerWithVerticalLine
          topLeft={
            <div>
              <div className="pre-cog-assets-drawer-conto-amount"> {numeral(state.totalAmount).format("0,0.00")} € </div>
              <div className="pre-cog-assets-drawer-subtitles"> <FormattedMessage id="preCog.assetsTab.drawer.existingAssetValue" /> </div>
            </div>      
          }
          bottomLeft={
            <div style={{ marginTop: "40px" }}>
              <div className="pre-cog-assets-drawer-conto-amount"> {numeral(state.totalResidualAmount).format("0,0.00")} € </div>
              <div className="pre-cog-assets-drawer-subtitles" > <FormattedMessage id="preCog.assetsTab.drawer.residualAt" /> {state.residualReferenceDate}</div>
            </div>
          }
          topRight={
            <div style={{paddingTop: "30px"}}>
              <div className="pre-cog-assets-drawer-subtitles"> <FormattedMessage id="preCog.assetsTab.drawer.activationDate2" /> {state.activationDate}</div>
            </div>
          }
          bottomRight={
            <div>
            </div>
          }
        />
        <TypesFilters 
          filterList={filterList}
          activeFilter={activeFilter} 
          setActiveFilter={setActiveFilter} 
        />
        <div className="pre-cog-assets-drawer-titles">
          <FormattedMessage id="preCog.assetsTab.drawer.fixedAsset" /> 
        </div>
        <VaporVerticalLine
          children={            
            state.logs?.map((s, index) => {
              return (
                <Fragment key={`stateLog_${index}`}>
                  <div className="pre-cog-assets-drawer-move-field" style={{ width: "40%" }}>
                    <div className="pre-cog-assets-drawer-move-field-bold">
                      <FormattedMessage id={`preCog.assetsTab.drawer.accountAssetsDetail.type.${s.type}`} />&nbsp; {moment(s.date).format("DD/MM/YYYY")}</div>
                    <div>{s.description}</div>
                  </div>
                  <div className="pre-cog-assets-drawer-move-field" style={{ width: "20%" }}>
                    <div>
                      <FormattedMessage id="preCog.assetsTab.drawer.movements.amount" />
                    </div>
                    <div className="pre-cog-assets-drawer-move-field-bold">
                      {/* logAmount */ numeral(s.depreciationQuota ? s.depreciationQuota : s.amount).format("0,0.00")} €</div>
                  </div>
                  <div className="pre-cog-assets-drawer-move-field" style={{ width: "20%" }}>
                    <div><FormattedMessage id="preCog.assetsTab.drawer.movements.residue" /> </div>
                    <div className="pre-cog-assets-drawer-move-field-bold">
                      {numeral(s.residualAmount).format("0,0.00")} € </div>
                  </div>
                  <div className="pre-cog-assets-drawer-move-field" 
                    onClick={() => {
                      setShowDrawerDetail(!showDrawerDetail);
                      setSelectedSequence(s?.sequence);
                    }}>
                    <FontAwesomeIcon
                      icon={["far", "arrow-right"]}
                      style={{ color: "rgb(0, 144, 209)", cursor: "pointer" }}
                    />
                  </div>
                </Fragment>
              );
            })            
          
          } />     
        { /* 
        https://teamsystem.atlassian.net/browse/DOP-1788 */
          assetsDetails.assetStatus === "ACTIVE" &&                    
        <div className="pre-cog-assets-drawer-add-movement">
          <Popover            
            trigger="focus"
            visible={showPopover}
            placement={"bottom"}
            content={
              <div data-testid='pre-cog-assets-drawer-popover' className='pre-cog-assets-drawer-popover'>
                <div className='pre-cog-assets-drawer-popover-field' onClick={() => {
                  setHideHeader(true);
                  setRemovalRevaluation(true);
                  setShowPopover(false);
                }}>     
                  <FormattedMessage id="preCog.assetsTab.drawer.buttons.delete" />
                </div>

                { /** Un cespite non può essere rivalutato 2 volre, l'operazione andrà in errore 
                 * quindi se nei logs ho un movimento di rivalutazione allora non mostro il bottone.
                 * TODO Ovviamente nei logs l'info ad oggi non arriva
                */
                  !state.logs.find(el => el?.type?.match(/REVALUATE/)) && state.logs.find(el => el?.type?.match(/DEPRECIATION/)) &&                
                <div className='pre-cog-assets-drawer-popover-field' 
                  onClick={() => {
                    setHideHeader(true);
                    setAddRevaluation(true);
                    setShowPopover(false);
                  }}><FormattedMessage id="preCog.assetsTab.drawer.buttons.revaluation" />
                </div>
                }

              </div>
            }
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            
            <div className='pre-cog-assets-drawer-add-movement-text'
              data-testid="popoverButtonDeleteRevaluate"
              onClick={() => {
                setShowPopover(prev => !prev);
              }}
              style={{cursor: "pointer"}}
            >
              <FontAwesomeIcon
                icon={["far", "plus-circle"]}
                className={"precog-withholding-drawer-form—icon"}                
              />
              <span style={{marginLeft: "8px"}}>
                <FormattedMessage id="preCog.assetsTab.drawer.buttons.addMovements" />
              </span>
            </div>
          </Popover>
        </div>
        }
      </div>}
          {addRevaluation && 
        <RevaluationSubSection assetId={assetsDetails.id} businessId={assetsDetails.businessId} 
          minDatePicker={minDatePicker} setHideHeader={setHideHeader} 
          setAddRevaluation={setAddRevaluation} setBottomButtons={setBottomButtons} 
          totalResidualAmount={state.totalResidualAmount} 
        />
          }
          {removalRevaluation && 
        <RemovalSubSection assetId={assetsDetails.id} businessId={assetsDetails.businessId} 
          setBottomButtons={setBottomButtons} state={state} 
          setHideHeader={setHideHeader} setRemovalRevaluation={setRemovalRevaluation}
        />
          }
        </div>}
      {showDrawerDetail && 
        <MovementDrawerDetails 
          trackType={activeFilter}
          assetsDetails={assetsDetails}
          sequence={selectedSequence} 
          setShowDrawerDetail={setShowDrawerDetail} 
          showDrawerDetail={showDrawerDetail} />
      }
    </div>
  );
};

export default MovementsSection;